import React from "react";
import "./RowsPerPageSelect.css";

const RowsPerPageSelect = ({
  value,
  onChange,
  options = [10, 20, 50, 100],
  label = "Rows per page",
  wrapperClassName = "",
  labelClassName = "",
  selectClassName = "",
  ariaLabel = "Rows per page",
}) => (
  <label className={["rows-per-page-select", wrapperClassName].filter(Boolean).join(" ")}>
    <span className={labelClassName}>{label}</span>
    <select className={selectClassName} value={value} onChange={(e) => onChange(Number(e.target.value))} aria-label={ariaLabel}>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  </label>
);

export default RowsPerPageSelect;
